let code = 'hebe'
let name = 'HEBE'
let pColor = '#0E73ED'
let sColor = '#041C3F'
let cColor = '#15C4D8'
let mColor = '#02060D'
let bColor = '#F0FAF2'
let iColor = '#FFFFFF'
let button = {
  light: {
    backgroundColor: '#15C4D8',
    color: '#FFFFFF',
    border: '2px solid #15C4D8',
  },
  dark: {
    backgroundColor: '#041C3F',
    color: '#FFFFFF',
    border: '2px solid #041C3F',
  }
}
let graph = [
  '#15C4D8',
  '#F294D9',
  '#041C3F',
  '#89F2E8',
  '#e3f2fd',
  '#90caf9',
  '#42a5f5',
  '#1e88e5',
  '#1565c0',
  '#0d47a1',
]
if (window.location.hostname.includes('marbu')) {
  code = 'marbu'
  name = 'Marbu'
  pColor = '#D6BA95'
  sColor = '#a56e26'
  cColor = '#a56e26'
  mColor = '#D6BA95'
  bColor = '#F6F7E7'
  iColor = '#FFFFFF'
  button = {
    light: {
      backgroundColor: '#D6BA95',
      color: '#000000',
      border: '2px solid #D6BA95',
    },
    dark: {
      backgroundColor: '#a56e26',
      color: '#FFFFFF',
      border: '2px solid #a56e26',
    }
  }
  graph = [
    '#a56e26',
    '#D6BA95',
    '#041C3F',
    // '#89F2E8',
    '#e3f2fd',
    '#90caf9',
    '#42a5f5',
    '#1e88e5',
    '#1565c0',
    '#0d47a1',
  ]
} else if (window.location.hostname.includes('telemuti')) {
  code = 'telemuti'
  name = 'TELEMUTI'
  pColor = '#006aeb'
  sColor = '#006aeb'
  cColor = '#006aeb'
  mColor = '#d8dfe6'
  bColor = '#FFFFFF'
  iColor = '#0448aa'
  button = {
    light: {
      backgroundColor: '#006aeb',
      color: '#FFFFFF',
      border: '2px solid #006aeb',
    },
    dark: {
      backgroundColor: '#0448aa',
      color: '#FFFFFF',
      border: '2px solid #0448aa',
    }
  }
  graph = [
    '#006aeb',
    '#F294D9',
    '#041C3F',
    '#89F2E8',
    '#e3f2fd',
    '#90caf9',
    '#42a5f5',
    '#1e88e5',
    '#1565c0',
    '#0d47a1',
  ]
} else if (window.location.hostname.includes('rekete')) {
//   Morado (#6B4C9A): Encabezados principales, logo, menú de navegación
// Naranja (#FF7428): Botones primarios (CTA), destacados, promociones
// Azul Oscuro (#2C3E50): Texto del cuerpo, pie de página, fondos alternos
// Turquesa (#00D9C0): Enlaces, iconos, botones secundarios, hover effects
// Rojo (#D32F2F): Ofertas urgentes, badges "nuevo", alertas importantes
  code = 'rekete'
  name = 'Rekete Facil'
  sColor = '#6B4C9A'
  pColor = '#006aeb'
  cColor = '#FF7428'
  mColor = '#2C3E50'
  bColor = '#FFFFFF'
  iColor = '#FFFFFF'
  button = {
    light: {
      backgroundColor: '#FF7428',
      color: '#FFFFFF',
      border: '2px solid #FF7428',
    },
    dark: {
      backgroundColor: '#2C3E50',
      color: '#FFFFFF',
      border: '2px solid #2C3E50',
    }
  }
  graph = [
    '#006aeb',
    '#F294D9',
    '#041C3F',
    '#89F2E8',
    '#e3f2fd',
    '#90caf9',
    '#42a5f5',
    '#1e88e5',
    '#1565c0',
    '#0d47a1',
  ]
} else if (window.location.hostname.includes('comtodotel')) {
  code = 'hebe'
  name = 'COMTODOTEL'
  pColor = '#0E73ED'
  sColor = '#041C3F'
  cColor = '#15C4D8'
  mColor = '#02060D'
  bColor = '#F0FAF2'
  iColor = '#FFFFFF'
  button = {
    light: {
      backgroundColor: '#15C4D8',
      color: '#FFFFFF',
      border: '2px solid #15C4D8',
    },
    dark: {
      backgroundColor: '#041C3F',
      color: '#FFFFFF',
      border: '2px solid #041C3F',
    }
  }
  graph = [
    '#0E73ED',
    '#F294D9',
    '#041C3F',
    '#89F2E8',
    '#e3f2fd',
    '#90caf9',
    '#42a5f5',
    '#1e88e5',
    '#1565c0',
    '#0d47a1',
  ]
}
import(`../assets/styles/${code}.css`);

export const title = name;
export const primaryColor = pColor;
export const secundaryColor = sColor;
export const contrastColor = cColor;
export const menuColor = mColor;
export const menuIcon = iColor;
export const backgroundColor = bColor;
export default {
  code,
  title,
  primaryColor,
  secundaryColor,
  contrastColor,
  menuColor,
  menuIcon,
  backgroundColor,
  button,
  graph
};